<vwui-form-group class="radio-group" role="radiogroup" [label]="label" [required]="required">
  @for (radioItem of radioItems; track trackByTitle($index, radioItem)) {
    <vwui-radio [name]="name" (vwuiChecked)="setRadioValue(radioItem.value)" [value]="radioItem.value" [checked]="isChecked(radioItem.value)">{{ radioItem.title | translate}}</vwui-radio>
  }
</vwui-form-group>
